// Roadblock Apis
export const RoadblockApiUrls = {
    get_roadblock_api : "/roadblockApi/getroadblockList"  
  };
  
  // Visual Panel Apis
  export const VisualpanelApiUrls = {
    get_visualpanel_api : "/visualpanelApi/getvisualpanelList"  
  };

// News / Admissions Apis
export const NewsApiUrls = {
  get_news_api : "/newsApi/getnewsList"  
};

// News / Year Apis
export const NewsTypeDistinctYearApiUrls = {
  get_news_type_distinct_year_api : "/newsApi/getnewstypedistinctyear"  
};

// News gallery
export const NewsGalleryApiUrls = {
  get_news_gallery_api : "/newsgalleryApi/getnewsgalleryList"  
};


// News On homepage  Api
export const NewsOnHomePageApiUrls = {
  get_newsOnHomePage_api : "/newsApi/getNewsForHomePageList"  
};

export const PeopleApiUrls = {
  get_people_api : "/peopleApi/getpeopleList"
}

//Publication api
export const PublicationsApiUrls = {
  get_publications_api : '/publicationsApi/getpublicationsList'
};

//publication year api
export const PublicationDistinctYearApiUrls = {
  get_publication_distinct_year_api : "/publicationsApi/getpublicationsdistinctyearForWebadmin"  
};

//Resources list api
export const ResourcesApiUrls = {
  get_resources_api : "/ResourcesApi/getResourceList"
}


// event home Apis
export const EventOnHomePageApiUrls = {
  get_event_homepage_api : "/eventforhomepageApi/geteventforhomepageList"  
};

// event Apis
export const EventApiUrls = {
  get_event_api : "/eventApi/geteventList"  
};

// Event gallery Apis
export const EventGalleryApiUrls = {
  get_event_gallery_api : "/eventgalleryApi/geteventgalleryList"  
};

//event api
export const EventDisYearApiUrls = {
  get_event_disyear_api : '/eventApi/getEventdistinctyear'
}

//event api
export const EventPresentationApiUrls = {
  get_event_presentation_api : '/eventdocumentApi/geteventdocumentList'
}

//careers api
export const CareersApiUlrs = {
  get_career_api :"/careerApi/getCareerList"
}


// NewsLetter api
export const NewsLetterApiUrls = {
  get_newsletter_api : '/nletterApi/getnletterList'
};

// NewsLetter / Year api
export const NewsLetterDistinctYearApiUrls = {
  get_newsletter_distinct_year_api : '/nletterApi/getnletterdistinctyear'
}